import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable';
import { FirebaseApp } from 'angularfire2';

import { Product } from '../entities/product.entities'
import { ProductService } from '../services/product.service'
import { Item } from '../entities/item.entities'
import { Router } from '@angular/router';

import { CartService } from '../services/cart.service'




import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";

import { AuthService } from '../services/AuthService'

@Injectable()
export class BuyService {

    historyUser: any[] = [];
    public order: any[] = [];
    checkHistory: boolean = false;
    private image;
    constructor(private firebaseApp: FirebaseApp, private productService: ProductService, public authService: AuthService, private af: AngularFireDatabase, public router: Router, private cart: CartService) {
        let history;
        history = this.af.list('/DetailBuy')
        history.subscribe((snap) => {
            this.historyUser = [];
            for (var i = 0; i < snap.length; i++) {
                if (snap[i].id == this.authService.email) {
                    this.historyUser.push(snap[i])
                }
            }
        })
        let order;
        order = this.af.list('/DetailBuy').map((array) => array.reverse()) as FirebaseListObservable<any[]>;
        order.subscribe((snap) => {
            this.order = snap
        })
    }
    getBuyItem(id){
        let dataTemp;
        let data = this.af.list('/DetailBuy')
        data.subscribe((snap)=>{
            for (var i = 0; i < snap.length; i++) {
                if (snap[i].uid == id) {
                    dataTemp = snap[i];
                }
            }
        })
        return dataTemp;
    }
    gethistory() {
        return this.af.list('/DetailBuy')
    }
    OrderBuy(id: string) {
        let orderId;
        let orderDetailId;
        orderId = this.af.list('/DetailBuy').map((array) => array.reverse()) as FirebaseListObservable<any[]>;
        orderId.subscribe((snap) => {
            orderDetailId = snap[id]
        })
        return orderDetailId
    }
    addProductsitem(data) {
        let addProduct = this.af.list('/product')
        // get Data link image 
        addProduct.push(data).then(res => {
            alert("เพิ่มสินค้าเสร็จสิ้น")
            location.reload();
        })

    }
    updatedataUpload(id: string, path: string) {
        let historyUserAuthen: any[] = [];
        let historyss = this.af.list('/DetailBuy')
        historyss.subscribe((snap) => {
            this.historyUser = [];
            for (var i = 0; i < snap.length; i++) {
                if (snap[i].id == this.authService.email) {
                    historyUserAuthen.push(snap[i])
                }
            }
        })
        let updateData = this.af.list('/DetailBuy')
        updateData.update(historyUserAuthen[id], { status: 'โอนเรียบร้อยรอการตรวจสอบ', confirmTransfer: path }).then(res => {
            alert("ส่งหลักฐานเสร็จสิ้น")
            location.reload();
        })
    }
    updateData(id, status, province) {
        let item;
        let order = this.af.list('/DetailBuy').map((array) => array.reverse()) as FirebaseListObservable<any[]>;
        order.subscribe((snap) => {
            item = snap[id];
        })
        order.update(item, { delivery: status, provinceCode: province }).then(res => {
            alert("Update Success")
        })

    }
    
    buyProduct(value: Item[], address: any, bank, totalMoney, sentMoney) {
        this.cart.totalPrice = 0
        let item;
        let date = new Date();
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        let time = date.getHours() + ':' + date.getMinutes()
        let itemCart: Item[] = [];
        for (var i = 0; i < value.length; i++) {
            if (value[i].quantity != 0) {
                itemCart.push(value[i])
            }
        }
        if (value != null) {
            
            let dataTemp;
            let uids = 1;
            item = this.af.list('/DetailBuy')
            let temp = this.af.list('/DetailBuy')
            temp.subscribe(snap => {
                dataTemp = snap.length
            })
            if (dataTemp == 0) {
                item.push({
                    uid: 1,
                    id: this.authService.email,
                    product: itemCart,
                    address: address,
                    bank: bank,
                    totalMoney: totalMoney + sentMoney,
                    date: day + '-' + month + '-' + year,
                    time: time,
                    provinceCode: '',
                    status: 'ยังไม่ได้ทำการโอน',
                    delivery: 'รอการตรวจสอบ',
                    confirmTransfer: 'No',
                    allProductCount:this.cart.cont
                }).then(res => {
                    this.router.navigate(['SuccessPage',1])
                })
            } else {
                
                temp.subscribe(snap => {
                    dataTemp = snap[snap.length - 1].uid
                })
                item.push({
                    uid: 1 + dataTemp,
                    id: this.authService.email,
                    product: itemCart,
                    address: address,
                    bank: bank,
                    totalMoney: totalMoney + sentMoney,
                    date: day + '-' + month + '-' + year,
                    time: time,
                    provinceCode: '',
                    status: 'ยังไม่ได้ทำการโอน',
                    delivery: 'รอการตรวจสอบ',
                    confirmTransfer: 'No',
                    allProductCount:this.cart.cont
                }).then(res => {
                    this.router.navigate(['SuccessPage',dataTemp])
                })
                
            }
            localStorage.removeItem('cart')
            this.cart.loadCart()
            //window.location.reload()

        }

    }

    // New Function ===========
    getOrder() {
        return this.af.list('/DetailBuy').map((array) => array.reverse()) as FirebaseListObservable<any[]>;
    }
    getNottify() {
        let nottify = 0;
        let data = this.af.list('/DetailBuy');
        data.subscribe((data) => {
            for (var i = 0; i < data.length; i++) {
                if (data[i].delivery == 'รอการตรวจสอบ') {
                    nottify++;
                }
            }
        },(error) => { console.log(error) },() => { return nottify } // <- this was never called
        );
    }
}


// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/services/buyservice.ts